import { Navigate, Outlet } from 'react-router-dom';

import { AdminShell } from '../shared/layout/AdminShell';
import { useAdminAuth } from './providers/useAdminAuth';

// PARA-106 §2/§3 (UI-архитектура) — редирект на /login при отсутствии
// admin_access_token (AC-E1). AC-E2 (403, чужой OWNER-токен) обрабатывается
// тем же путём через onUnauthorized в api/client.ts.
export function ProtectedLayout(): JSX.Element {
  const { status } = useAdminAuth();

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace />;
  }

  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  );
}
